import "./App.css";
import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import AuthCallback from "./pages/AuthCallback";
import Landing from "./pages/Landing";
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import ResetPassword from "./pages/ResetPassword";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
import Guidelines from "./pages/Guidelines";
import Founders from "./pages/Founders";
import Contact from "./pages/Contact";
import AppShell from "./components/Layout/AppShell";
import Home from "./pages/Home";
import Quest from "./pages/Quest";
import ChildSafety from "./pages/ChildSafety";
import DeleteAccount from "./pages/DeleteAccount";
import Feed from "./pages/Feed";
import Planets from "./pages/Planets";
import PlanetDetail from "./pages/PlanetDetail";
import Gifts from "./pages/Gifts";
import Games from "./pages/Games";
import Menu from "./pages/Menu";
import Help from "./pages/Help";
import Messages from "./pages/Messages";
import Profile from "./pages/Profile";
import PublicProfile from "./pages/PublicProfile";
import Ranks from "./pages/Ranks";
import Dating from "./pages/Dating";
import Pets from "./pages/Pets";
import Leaderboard from "./pages/Leaderboard";
import NotificationsPage from "./pages/NotificationsPage";
import Admin from "./pages/Admin";
import NotFound from "./pages/NotFound";
import PaymentResult from "./pages/PaymentResult";
import { Toaster } from "./components/ui/sonner";

function Shell() {
  const loc = useLocation();

  // Splash interstitial removed — visitors land directly on the page.
  // Mark splashed immediately + fire the event so components like CountUp
  // (which wait for the splash to dismiss) start their animations at once.
  useEffect(() => {
    if (sessionStorage.getItem('wv_splashed') !== '1') {
      sessionStorage.setItem('wv_splashed', '1');
      window.dispatchEvent(new CustomEvent('wv:splash-done'));
    }
  }, []);

  // Detect Google callback synchronously
  if (loc.hash?.includes('session_id=')) return <AuthCallback />;

  return (
    <>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/child-safety" element={<ChildSafety />} />
        <Route path="/founders" element={<Founders />} />
        <Route path="/delete-account" element={<DeleteAccount />} />
        <Route path="/guidelines" element={<Guidelines />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/payment-result" element={<PaymentResult />} />
        <Route path="/app" element={<ProtectedRoute><AppShell /></ProtectedRoute>}>
          <Route index element={<Home />} />
          <Route path="quest" element={<Quest />} />
          <Route path="feed" element={<Feed />} />
          <Route path="planets" element={<Planets />} />
          <Route path="planets/:id" element={<PlanetDetail />} />
          <Route path="gifts" element={<Gifts />} />
          <Route path="games" element={<Games />} />
          <Route path="menu" element={<Menu />} />
          <Route path="help" element={<Help />} />
          <Route path="messages" element={<Messages />} />
          <Route path="profile" element={<Profile />} />
          <Route path="users/:uid" element={<PublicProfile />} />
          <Route path="ranks" element={<Ranks />} />
          <Route path="dating" element={<Dating />} />
          <Route path="pets" element={<Pets />} />
          <Route path="leaderboard" element={<Leaderboard />} />
          <Route path="notifications" element={<NotificationsPage />} />
          <Route path="admin" element={<Admin />} />
          <Route path="*" element={<NotFound />} />
        </Route>
        <Route path="*" element={<NotFound />} />
      </Routes>
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Shell />
        </AuthProvider>
      </BrowserRouter>
      <Toaster
        theme="dark"
        position="top-right"
        expand
        richColors={false}
        closeButton={false}
        offset={16}
        visibleToasts={5}
        style={{ zIndex: 2147483647 }}
      />
    </div>
  );
}

export default App;
